import React, { createContext, FC, PropsWithChildren } from "react";

import { useWebResponsive } from "./use-responsive";
import { defaultResponsiveValue } from "./default-values";

export const ResponsiveContext = createContext(defaultResponsiveValue);

ResponsiveContext.displayName = "ResponsiveContext";

export const ResponsiveContextProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  return (
    <ResponsiveContext.Provider value={useWebResponsive()}>
      {children}
    </ResponsiveContext.Provider>
  );
};
